module.exports = __webpack_public_path__ + "img/9x16_repeat.167d6727.jpg";